module.exports = __webpack_public_path__ + "static/media/ippsa.3490830a.jpg";